// Dependencies
import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

// Styles
import "./SearchDynamicHall.component.scss";
import { boolean } from "yup";

export interface SearchDynamicHallProps {
    onSearch: any;
    isLoading: boolean;
    clearSearchTerm: boolean;
}
export interface SearchDynamicHallState {
    search_term: string;
    clearSearchTerm: boolean;
}

export default class SearchDynamicHall extends Component<
    SearchDynamicHallProps,
    SearchDynamicHallState
> {
    constructor(props) {
        super(props);
        this.state = {
            search_term: "",
            clearSearchTerm: false
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.clearSearchTerm && nextProps.clearSearchTerm !== this.state.clearSearchTerm) {
            this.props.onSearch("");
            this.setState({
                search_term: "",
                clearSearchTerm: nextProps.clearSearchTerm
            });
        }
    }

    focusSearch = e => {
        e.stopPropagation();
    };

    onChange = e => {
        this.props.onSearch(e.target.value);
        this.setState({
            search_term: e.target.value,
            clearSearchTerm: false
        });
    };

    deleteSearch = e => {
        this.props.onSearch("");
        this.setState({search_term: ""});
    };

    render() {
        return (
            <div className="search-items-container">
	            <input
		            value={this.state.search_term}
		            placeholder="Hall Name"
		            onChange={this.onChange}
		            onClick={this.focusSearch}
	            />
                {this.props.isLoading && (
                    <Components.LoadingRipple width={"30px"} height={"30px"}/>
                )}
                {!this.props.isLoading && (
                    <button className="remove-obj-button"
                            onClick={this.deleteSearch}>
                        <i className="icon-times-solid"></i>
                    </button>
                )}
            </div>
        );
    }
}
